import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CalendarModule } from "@bfx/primeng/calendar";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DialogModule } from "@bfx/primeng/dialog";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { FieldsetModule } from "@bfx/primeng/fieldset";
import { InputSwitchModule } from "@bfx/primeng/inputswitch";
import { MenuModule } from "@bfx/primeng/menu";
import { MultiSelectModule } from "@bfx/primeng/multiselect";
import { SliderModule } from "@bfx/primeng/slider";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { TabViewModule } from "@bfx/primeng/tabview";

import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";
import { BfxBlotterOrdersModule } from "../bfx-blotter-orders/bfx-blotter-orders.module";
import { BfxFindOrdersFilterDataFactory } from "./bfx-find-orders-filter-data-factory";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxFindOrdersContextMenuService } from "./bfx-find-orders-contextmenu.service";
import { BfxFindService } from "../bfx-find/bfx-find.service";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { BfxFindOrdersContextMenu } from "./bfx-find-orders-contextmenu";
import { BfxFindOrdersService } from "./bfx-find-orders.service";
import { BfxFindOrdersComponent } from "./bfx-find-orders.component";
import { BfxFindOrdersFilterViewComponent } from "./bfx-find-orders-filter-view.component";
import { BfxFindModule } from "app/bfx-find/bfx-find.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    AutoCompleteModule,
    BfxBlotterFilterModule,
    BfxBlotterOrdersModule,
    BfxElementsLibraryModule,
    BfxFindModule,
    BfxInterfaceControlsModule,
    BfxSharedModule,
    ButtonModule,
    CalendarModule,
    CommonModule,
    DataTableModule,
    DialogModule,
    DropdownModule,
    FieldsetModule,
    FlexLayoutModule,
    FormsModule,
    InputSwitchModule,
    MenuModule,
    MultiSelectModule,
    PerfectScrollbarModule,
    SliderModule,
    SpinnerModule,
    TabViewModule,
    TranslateModule,
    NativeDesktopModule,
    BaseComponentsModule,
  ],
  declarations: [
    BfxFindOrdersComponent,
    BfxFindOrdersContextMenu,
    BfxFindOrdersFilterViewComponent,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxFindOrdersService,
    { provide: BfxFindService, useExisting: BfxFindOrdersService },
    BfxFindOrdersContextMenuService,
    BfxBaseBlotterColumnSelectorService,
    BfxFindOrdersFilterDataFactory,
  ],
  exports: [BfxFindOrdersComponent, BfxFindOrdersFilterViewComponent],
  bootstrap: [BfxFindOrdersComponent],
})
export class BfxFindOrdersModule {}
